// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Caution: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53 47"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M25.7 30.9H27c.5 0 .9-.4.9-.9V14.2c0-.5-.4-.9-.9-.9h-1.3c-.5 0-.9.4-.9.9V30c0 .5.4.9.9.9zm.8 8.5c1.2 0 2.2-1 2.2-2.2 0-1.2-1-2.2-2.2-2.2-1.2 0-2.2 1-2.2 2.2 0 1.2 1 2.2 2.2 2.2z"/><path d="M51.9 40.9L29.6 2.3C28.9 1.1 27.7.5 26.5.5c-1.3 0-2.6.7-3.1 1.9L1.1 40.9c-.7 1.1-.7 2.5 0 3.6.7 1.2 1.9 1.8 3.1 1.8h44.6c1.2 0 2.4-.7 3.1-1.8.7-1 .7-2.4 0-3.6zM25.8 3.7c.1-.3.5-.4.7-.4.2 0 .5.1.7.3l22.4 38.8c.2.2.2.6 0 .8v.1c-.1.2-.4.4-.8.4H4.2c-.3 0-.6-.2-.8-.5-.2-.2-.2-.6 0-.9L25.8 3.7z"/></svg>;
};

export default React.memo(Caution);
